export default __webpack_public_path__ + "static/media/android.92cab723.svg";